import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  templateUrl: './not-found.component.html',
  imports: [TranslatePipe]
})
export class NotFoundComponent {}
